angular.module('rjmNg.api').factory("Reference", [
  "Columns"
  "$q"
  (Columns, $q) ->

    _modifyFromColumnForReference = (column, to) ->
      column.reference_column_id = to.column
      return _modifyColumnForReference(column)

    _modifyColumnForReference = (column) ->
      column.is_referenceable = true
      prop = column.properties
      if column.type is 'derivative' and prop.derivative_type is 'calculation'
        if not column.properties.syntax?
          column.properties.syntax = ""
      return column

    class Reference
      constructor: (from, to, structure) ->
        @from = from
        @to = to
        @name = @_generateName(structure)
        @fromColumn = structure.columns[@from.column]
        @toColumn = structure.columns[@to.column]

      # Force parameter will make this change even if the reference_column_id is already set
      save : (force=false) ->
        deferred = $q.defer()

        unless @_validateReference()
          deferred.reject "Invalid reference"
          return deferred.promise

        # Get the column, modify it, and save it
        Columns.get(@from.column).then( (column) =>
          # Don't change an existing reference unless we force it`
          if column.reference_column_id is 0 or force
            column = _modifyFromColumnForReference(column, @to)
            Columns.save(column).then( (column) ->
              deferred.resolve(column)
            , (error) ->
              deferred.reject(error)
            )
          else
            deferred.reject("Can't create path. <strong>#{column.name}</strong> column already has a path")
        , (error) ->
          deferred.reject(error)
        )

        Columns.get(@to.column).then( (column) =>
          column = _modifyColumnForReference(column)
          Columns.save(column).then( (column) ->
            deferred.resolve(column)
          , (error) ->
            deferred.reject(error)
          )
        , (error) ->
          deferred.reject(error)
        )

        return deferred.promise

      delete : () ->
        deferred = $q.defer()

        # Get the column, modify it, and save it
        Columns.get(@from.column).then( (column) ->
          column.reference_column_id = 0
          Columns.save(column).then((column) -> deferred.resolve(column))
        )

        return deferred.promise

      _isDatetime : (type) ->
        type is 'inst'

      _validateReference : () ->
        unless @_validateTo(@to) and @_validateFrom(@from)
          return false

        fromDataType = @fromColumn.data_type.type
        toDataType = @toColumn.data_type.type
        return ((@_isDatetime(fromDataType) and @_isDatetime(toDataType)) or
          (not @_isDatetime(fromDataType) and not @_isDatetime(toDataType)))


      _validateTo : (to) ->
        to.table? and to.column?

      _validateFrom : (from) ->
        from.table? and from.column?

      getLocalColumnId : (tableId) ->
        switch tableId
          when @from.table then @from.column
          when @to.table then @to.column
          else
            throw "Cannot find local column id for this reference"

      getForeignColumnId : (tableId) ->
        if tableId isnt @to.table
          return @to.column
        else if tableId isnt @from.table
          return @from.column
        else
          throw "Cannot find remote column id for this reference"

      # Return a human readable name for this reference
      _generateName : (structure) ->
        unless structure?
          return "#{@from.table}.#{@from.column} to #{@to.table}.#{@to.column}"

        if Object.keys(structure).length > 0
          "#{structure.tables[@from.table].name}." +
          "#{structure.columns[@from.column].name} = " +
          "#{structure.tables[@to.table].name}." +
          "#{structure.columns[@to.column].name}"
        else
          ""
  ]
)
